export const noEmptyObject = (obj: any): any => {
  if (obj !== null && typeof obj === 'object' && !Array.isArray(obj)) {
    for (const key in obj) {
      obj[key] = noEmptyObject(obj[key]);
      if (
        obj[key] === undefined ||
        (typeof obj[key] === 'object' &&
          !Array.isArray(obj[key]) &&
          Object.keys(obj[key]).length === 0)
      ) {
        delete obj[key];
      }
    }
  }
  return obj;
};
